import React, { useEffect } from 'react';
import './Contact.css';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaInstagram, FaFacebook, FaLinkedin } from 'react-icons/fa';

const Contact = () => {
   // Inject Paperbell script once component mounts
  useEffect(() => {
    const scriptId = 'paperbellCalendarEmbedScript';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.type = 'text/javascript';
      script.src = 'https://js.paperbell.com/calendar-embed.js';
      document.head.appendChild(script);
    }
  }, []);
    const handleManualRender = () => {
   window.location.reload();
  };
  return (
    <>
    <div className="contact">
  <h1>Contact Page</h1>
    <p>Get in touch with us!</p>
      <div className="section-box">
  
        <div className="contact-info">
          <h3>Mark Ambrosio</h3>
        
          <a 
            href="tel:+4169970299" 
            className="contact-item"
          >
            <FaPhone className="contact-icon" />
            <div className="contact-text">
         
              <p>+1 (416) 997-0299</p>
            </div>
          </a>
          <a 
            href="mark@bulletproofinterviewing.com" 
            className="contact-item"
          >
            <FaEnvelope className="contact-icon" />
            <div className="contact-text">
             
              <p>mark@bulletproofinterviewing.com</p>
            </div>
          </a>
      
    {/* <a href="#" target="_blank" rel="noopener noreferrer">
      <FaInstagram className="contact-icon" />
    </a>
    <a href="#" target="_blank" rel="noopener noreferrer">
      <FaFacebook className="contact-icon" />
    </a>
    <a href="#" target="_blank" rel="noopener noreferrer">
      <FaLinkedin className="contact-icon" />
    </a> */}
  
        </div>
      </div>
            <h1 className="contact-heading">Book Your Free Consultation</h1>
      <p className="contact-subtext">Choose a time that works for you using the calendar below.</p>

      {/* Embedded Paperbell calendar */}
      <div
        className="paperbell-calendar-container"
        data-package-id="153289"
        style={{ width: '100%' }}
      /> <button
        onClick={handleManualRender}
        style={{
          marginTop: "2rem",
          padding: "0.75rem 1.5rem",
          background: "#456882",
          color: "#fafafa",
          border: "none",
          borderRadius: "20px",
          cursor: "pointer",
          fontSize: "1rem",
        }}
      >
        Not seeing the form? Click here to refresh
      </button>
    </div>
         
      </>
  );
};

export default Contact;
